import { calculateOrganisationColors } from '../theme/organization-theme-model';

import styles from './organization-palette.module.less';
export const DisplayColorPalette = ({
    primaryColor,
    secondaryColor,
    tertiaryColor,
    setColor,
    selected,
    current,
    onClick,
}) => {
    const colors = calculateOrganisationColors(primaryColor);
    return (
        <div
            className={[styles.paletteContainer, selected || current === primaryColor ? styles.selected : ''].join(' ')}
            onClick={() => {
                if (onClick) {
                    onClick();
                }
                if (setColor) {
                    setColor(primaryColor);
                }
            }}
        >
            <div className={styles.left} style={{ backgroundColor: secondaryColor || colors.secondaryColor }}>
                &nbsp;
            </div>
            <div className={styles.center} style={{ backgroundColor: primaryColor }}>
                &nbsp;
            </div>
            <div className={styles.right} style={{ backgroundColor: tertiaryColor || colors.tertiaryColor }}>
                &nbsp;
            </div>
        </div>
    );
};
